import { UserTableSettingsDto } from '@/core';
import { ColumnsType } from 'antd/lib/table';
import { isEmpty } from 'lodash';
import { ColumnState } from './ColumnMenuItem';

export function selectHidden(columns: ColumnState[]) {
  return columns
    .filter((column) => !column.enabled)
    .map((column) => column.key)
    .join(',');
}

export function createColumnOptions<T>(
  columns: ColumnsType<T>,
  settings: Pick<Partial<UserTableSettingsDto>, 'hiddenColumns'> | undefined,
  defaultHiddenColumnKeys?: string[],
): ColumnState[] {
  const hiddenColumnsKeys = settings?.hiddenColumns?.split(',') ?? [];
  const defaultHidden = defaultHiddenColumnKeys ?? [];

  return columns.map((column) => ({
    title: column.title as React.ReactNode,
    key: column.key!,
    enabled: !isEmpty(hiddenColumnsKeys)
      ? !hiddenColumnsKeys.includes(column.key!.toString())
      : !defaultHidden.includes(column.key!.toString()),
  }));
}
